<!--
 * @Description: In User Settings Edit
 * @Author: laikt
 * @LastEditors: laikt
 * @Date: 2019-02-27 15:36:35
 * @LastEditTime: 2019-03-21 19:35:20
 -->
<template>
  <div class="nav" :style="{ position: positionin }">
    <el-row type="flex" class="row-bg">
      <el-col :offset="2" :span="22">
        <el-col :span="20" class="head" style="display: flex;">
          <div style="height: 60px;display: flex;align-items: center;cursor: pointer;">
             <img @click="tohome" src="@/assets/images/logooo.png" alt="" style="height: 40px"/>
          </div>
          <el-menu
            mode="horizontal"
            :default-active="activeIndex"
            class="el-menu-demo"
            background-color="#221814"
            text-color="#fff"
            active-text-color="#ffd04b"
          >
            <template v-for="item in menuTop">
              <template v-if="item.children">
                <el-submenu :index="item.id" popper-append-to-body>
                  <el-menu-item
                    slot="title"
                    :disabled="item.demoFlag == ''"
                    @click="handleSelect(item)"
                    :class="item.demoFlag == '' ? 'cursortext' : ''"
                    :index="item.id"
                    >{{ item.name }}</el-menu-item
                  >

                  <template
                    v-if="childItem.children"
                    v-for="childItem in item.children"
                  >
                    <!-- <ul class="unstable"> -->
                    <el-submenu
                      popper-append-to-body
                      :disabled="childItem.demoFlag === ''"
                      :class="childItem.demoFlag === '' ? 'hoverq' : ''"
                      :index="childItem.id"
                      @click="handleSelect(childItem)"
                    >
                      <template slot="title" v-if="childItem.name"
                        ><div @click="handleSelect(childItem)">
                          {{ childItem.name }}
                        </div></template
                      >

                      <!-- <el-menu-item
                  v-if="childItem.name"
                  @click="handleSelect(childItem)"
                >
                  {{ childItem.name }}
                </el-menu-item> -->

                      <el-menu-item
                        :index="items.id"
                        v-for="items in childItem.children"
                        :key="items.id"
                        @click="handleSelect(items)"
                        >{{ items.name }}</el-menu-item
                      >
                      <!-- <el-submenu index="2-4">
<template slot="title">选项4</template>
<el-menu-item index="2-4-1">选项1</el-menu-item>
<el-menu-item index="2-4-2">选项2</el-menu-item>
<el-menu-item index="2-4-3">选项3</el-menu-item>
</el-submenu> -->
                    </el-submenu>
                    <!-- <li> -->

                    <!-- </li> -->
                    <!-- </ul> -->
                  </template>

                  <template
                    v-if="!childItem.children"
                    v-for="childItem in item.children"
                  >
                    <ul class="clearn">
                      <el-menu-item
                        :index="childItem.id"
                        @click="handleSelect(childItem)"
                      >
                        {{ childItem.name }}
                      </el-menu-item>
                    </ul>
                  </template>
                </el-submenu>
              </template>
              <template v-else>
                <el-menu-item @click="handleSelect(item)" :index="item.id">{{
                  item.name
                }}</el-menu-item>
              </template>
            </template>
          </el-menu>
            <div style="height: 60px;display: flex;padding-left: 10px;align-items: center;">
                <img
                    class="teleiphone"
                    src="@/assets/images/teleiphone.png"
                    alt=""
                />
            </div>
        </el-col>
        <el-col :span="4">
          <div class="login-regist">
            <ul class="personal" v-if="this.userName !== ''">
              <li>
                <span style="margin-right: 20px">{{ this.userName }}</span>
              </li>
              <li class="showed">
                <span @click="toLink('在线下单')">会员中心 </span>
                <div class="bground">
                  <ul class="inistration">
                    <li @click="toLink('地址簿')">地址簿管理</li>
                    <li @click="toLink('个人信息')">个人信息</li>
                    <li @click="toLinkclearSesion('退出登录', '1')">
                      退出登录
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
            <div v-else>
              <a @click="toLink('注册', '1')">注册</a> <span>|</span>
              <a @click="toLink('登录', '1')">登录</a>
            </div>
          </div>
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Bus from "@/utils/bus";
import { mapGetters } from "vuex";
import { menuqueryaddressid } from "@/api/menu";
import { getHomeCenterUser, lougout } from "@/api/homePage";

export default {
  data() {
    return {
      positionin: "",
      activeIndex: "97AAB3AA-0B0C-D385-B987-2BA46580D87B",
      activename: "",
      routerUrl: "",
      // menuList: []
    };
  },
  created() {
    this.aueryfindbytype();
    if (this.$route.path == "/") {
      this.positionin = "fixed";
    } else {
      this.positionin = "relative";
    }
    this.activeIndex =
      sessionStorage.getItem("activeIndex") || this.$route.query.id;
  },
  computed: {
    ...mapGetters(["menuTop", "userName"]),
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      this.activeIndex = to.query.id;
      if (to.path == "/") {
        this.positionin = "fixed";
      } else {
        this.positionin = "relative";
      }
    },
  },
  methods: {
    tohome() {
      this.$router.push("/home");
      this.$store.dispatch("ParentList", "");
    },
    aueryfindbytype() {
      menuqueryaddressid({ name: "登录", sign: "1" }).then((res) => {
        if (res.status == 2000) {
          this.routerUrl = res.data.routAddress;
        }
      });
    },
    toLinkclearSesion(name, sign) {
      let MenuQueryDto = {};
      if (sign) {
        MenuQueryDto = { name: name, sign: sign };
      } else {
        MenuQueryDto = { name: name };
      }
      let ref = this;
      menuqueryaddressid(MenuQueryDto).then((res) => {
        if (res.data) {
          let token = sessionStorage.getItem("token");
          lougout(res.data.routAddress, { token: token }).then((res) => {
            if (res.status == 2000) {
              this.$store.commit("USERNAME", "");
              sessionStorage.removeItem("userInfoView");
              sessionStorage.removeItem("userInfo");
              sessionStorage.removeItem("token");
              this.$message({
                message: res.message,
                type: "success",
              });
              this.$router.push({
                path: "/",
              });
            } else {
              this.$message({
                message: res.message,
                type: "warning",
              });
            }
          });
        }
      });
    },
    toLink(name, sign) {
      let MenuQueryDto = {};
      if (sign) {
        MenuQueryDto = { name: name, sign: sign };
      } else {
        MenuQueryDto = { name: name };
      }
      menuqueryaddressid(MenuQueryDto).then((res) => {
        this.$store.dispatch("UpdateActive", res.data);
      });
    },
    handleSelect(item) {
      var need = "";
      if (
        item.name !== "查物流" &&
        item.name !== "查时效" &&
        item.name !== "查网点" &&
        item.name !== "在线下单" &&
        item.name !== "寄件服务" &&
        item.name !== "查询服务"
      ) {
        need = "1";
      }
      if (item.demoFlag == "/demoModel" && need === "1") {
        let islogin = sessionStorage.getItem("userInfoView");
        if (islogin == null) {
          sessionStorage.setItem("activeIndex", item.id);
          window.open(this.routerUrl + "/demoModel?id=" + item.id, "_self");
          return;
        } else {
          if (item.name == "首页") {
            this.$router.push({
              path: item.demoFlag,
            });
          } else {
            this.$router.push({
              path: item.demoFlag,
              query: {
                id: item.id,
              },
            });
          }
        }
      } else {
        if (item.opennew !== "1") {
          let idflag = item.id;
          //增加跳转别菜单的判断
          if (item.urlMenu == "4") {
            window.open(item.demoFlag, "_self");
          }
          if (item.urlMenu === "3") {
            let array = item.parentIds.split(",");
            idflag = array[array.length - 1];
          }
          // this.$store.dispatch("ParentList", "");
          if (item.name == "首页") {
            this.$router.push({
              path: item.demoFlag,
            });
          } else {
            this.$router.push({
              path: item.demoFlag,
              query: {
                id: idflag,
              },
            });
          }
        } else {
          this.$store.dispatch("UpdateActive", item);
        }
      }
    },
    inspect() {},
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.nav {
  width: 100%;
  // position: fixed;
  background-color: #221814;
  z-index: 100;
  height: 60px;
  min-width: 1400px;
  a {
    text-decoration: none;
  }
  .el-row {
    .el-col {
      .head {
        /deep/ .el-menu {
          background-color: #221814 !important;
          z-index: 99;
          .el-icon-arrow-down {
            display: none;
          }
          .hoverq {
            cursor: text;
            opacity: 1;
          }
          .operation {
            float: right;
            .nologin {
              line-height: 90px;
              color: #fff;
              span {
                // width: 30px;
                float: left;
                margin: 0 15px;
              }
            }
          }
          .operation:focus {
            outline: none;
          }

          .teleiphone {
            position: relative;
            top: 15px;
            left: 36px;
          }
          .teleiphone:focus {
            outline: none;
          }
        }
      }
      .login-regist {
        line-height: 14px;
        margin-top: 24px;
        // margin-left: 40px;
        .personal {
          li {
            float: left;
          }
          .showed:hover .bground {
            display: block;
          }
          .bground {
            display: none;
            padding-top: 22px;
            .inistration {
              width: 100px;
              height: 102px;
              padding-top: 9px;
              background-color: #221814;
              border-radius: 1px;
              margin-left: -17px;
              li {
                clear: both;
                text-align: center !important;
                padding: 7px 0;
                margin-left: 12px;
                color: #fff;
                margin-top: 2px;
                font-size: 14px;
                cursor: pointer;
              }
              li:hover {
                color: #fabe00;
              }
            }
          }
        }
        span {
          color: #fff;
        }
        a {
          color: #fff;
          font-size: 15px;
          padding: 0 18px;
        }
        a:first-child {
          // border-right: 1px solid #eee;
        }
        a:nth-last-of-type(-n + 2) {
          padding: 0 10px;
        }
        a:hover {
          color: #fda20c;
        }
      }
    }
  }
}
.clearn {
  .el-menu-item {
    color: #fff !important;
    font-size: 15px !important;
    a {
      color: #e8e8e8;
      position: relative;
      top: -2px;
    }
  }
  .el-menu-item:hover {
    color: #fabe00 !important;
    a {
      color: #fabe00 !important;
    }
  }
  .el-menu-item.is-active {
    color: #fabe00 !important;
  }
  li {
    .el-menu-item {
      // font-weight: 520;
      color: #e8e8e8 !important;
      font-size: 14px !important;
      line-height: 35px !important;
      height: 35px !important;
    }
    .el-menu-item:hover {
      color: #fabe00 !important;
    }
    .el-menu-item.is-active {
      color: #fabe00 !important;
    }
  }
}
.unstable {
  float: left;
  // border-right: 1px solid #ccc;
  margin-top: 12px;
  padding-bottom: 12px;
  .el-menu-item {
    // text-align: center;
    color: #fff !important;
    font-size: 15px !important;
    // font-weight: 600;
    a {
      color: #e8e8e8;
      position: relative;
      top: -2px;
    }
  }
  .hoverq {
    cursor: text;
    opacity: 1;
  }
  .el-menu-item:hover {
    color: #fabe00 !important;
    a {
      color: #fabe00 !important;
    }
  }
  .el-menu-item.is-active {
    color: #fabe00 !important;
  }
  li {
    .el-menu-item {
      // font-weight: 520;
      color: #e8e8e8 !important;
      font-size: 14px !important;
      line-height: 35px !important;
      height: 35px !important;
    }
    .el-menu-item:hover {
      color: #fabe00 !important;
    }
    .el-menu-item.is-active {
      color: #fabe00 !important;
    }
  }
}
.unstable:nth-child(2) {
  // margin-left: 35px;
}
</style>
